import qs from "query-string";

export type UrlParamValueType = number | string | undefined;
export type UrlParamType = Record<
  string,
  UrlParamValueType | UrlParamValueType[]
>;

export function stringifyUrl(params: UrlParamType) {
  return qs.stringify(
    Object.entries(params).reduce(
      (accum, [key, value]) => {
        if (Array.isArray(value)) {
          value = value.join(",");
        }
        accum[key] = value;
        return accum;
      },
      {} as Record<string, UrlParamValueType>
    )
  );
}

export function formDataToUrl(data: FormData) {
  const serialized = Array.from(data.entries()).reduce(
    (accum, [key, value]) => {
      if (value instanceof File) {
        return accum;
      }

      if (key in accum) {
        if (Array.isArray(accum[key])) {
          (accum[key] as Array<string | number>).push(value);
        } else {
          accum[key] = [accum[key] as UrlParamValueType, value];
        }
      } else {
        accum[key] = value;
      }

      return accum;
    },
    {} as UrlParamType
  );

  return stringifyUrl(serialized);
}

export function urlWithProtocol(url: string) {
  return url.toLocaleLowerCase().startsWith("http") || url.startsWith("//")
    ? url
    : `http://${url}`;
}

export function linkPropsWithSource(
  url: string,
  gameSlug?: string
): React.ComponentProps<"a"> {
  const parsed = new URL(urlWithProtocol(url));
  parsed.searchParams.set("utm_source", "morty.app");
  parsed.searchParams.set("utm_medium", "referral");
  if (gameSlug) {
    parsed.searchParams.set("utm_content", gameSlug);
  }

  return {
    children: parsed.host,
    href: parsed.toString(),
  };
}

interface GameBookingLinkType {
  bookingUrl?: string;
  location: {
    company: {
      url?: string;
    };
    url?: string;
  };
  slug?: string;
  url?: string;
}

export function bookingLinkProps(game: GameBookingLinkType) {
  const url =
    game.bookingUrl ||
    game.url ||
    game.location.url ||
    game.location.company.url;

  return url ? linkPropsWithSource(url, game.slug) : undefined;
}
